import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Sort,
  Filter,
} from "@syncfusion/ej2-react-grids";
import { GetSaleOrderDetailShipmentByID, GetSaleOrderDetail } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddCus.css";
import { Container, Col, Row } from "react-bootstrap";

const ViewEstimation = () => {
  const [AllProducts, setAllProducts] = useState("");
  const [customer, setcustomer] = useState(" ");
  //const [customer_po_no, setcustomer_po_no] = useState(" ");
  const [project_name, setproject_name] = useState(" ");
  const [sale_date, setsale_date] = useState(" ");
  //const [ship_method, setship_method] = useState(" ");
  //const [tracking_no, settracking_no] = useState(" ");
  const [total_price, settotal_price] = useState(" ");
  //const [amount_paid, setamount_paid] = useState(" ");
  //const [amount_pending, setamount_pending] = useState(" ");
  const [status, setstatus] = useState(" ");
  const [user, setuser] = useState(" ");
  const [so_note, setso_note] = useState(" ");
  const [tax, settax] = useState(" ");
  const [shipment, setshipment] = useState(" ");

  let param = useParams();
  const so_id = param.so_id;
  const navigate = useNavigate();
  const { currentColor, userID, userToken } = useStateContext();

  const customersGrid = [
    {
      headerText: "Product Code",
      field: "code",
      width: "150",
      textAlign: "Center",
    },
    {
      headerText: "Product",
      field: "product",
      width: "240",
      textAlign: "left",
    },
    {
      headerText: "Vendor",
      field: "vendor",
      width: "160",
      textAlign: "left",
    },
    {
      field: "quantity",
      headerText: "Qty",
      width: "100",
      textAlign: "right",
    },
    {
      field: "unit_price",
      headerText: "Unit Price",
      format: "C2",
      width: "150",
      textAlign: "right",
    },
    {
      field: "discount",
      headerText: "Discount",
      width: "150",
      format: "C2",
      textAlign: "right",
    },
    {
      field: "e_total",
      headerText: "Total",
      format: "C2",
      width: "140",
      textAlign: "right",
    },
    {
      field: "notes",
      headerText: "Notes",
      width: "240",
      textAlign: "left",
    },
  ];

  const handleBackClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    try {
      // console.log("Back");
      navigate("/Estimates");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (so_id && userID && userToken) {
      TimeoutUtility.resetTimeout();
      const resp = GetSaleOrderDetailShipmentByID(so_id, userID, userToken);
      resp
        .then(function (result) {
          setAllProducts(result.data);
        })
        .catch((err) => {
          console.log(err.message);
        });

      const resp1 = GetSaleOrderDetail(so_id, userID, userToken);
      resp1
        .then(function (result) {
          setcustomer(result.data[0].customer);
          //setcustomer_po_no(result.data[0].customer_po_no || "");
          setproject_name(result.data[0].project_name || "");
          setsale_date(result.data[0].e_date);
          //setship_method(result.data[0].ship_method || "");
          //settracking_no(result.data[0].tracking_no || "");
          settotal_price(result.data[0].total_price || "0");
          //setamount_paid(result.data[0].amount_paid || "");
          //setamount_pending(result.data[0].amount_pending || "");
          setstatus(result.data[0].status || "");
          setuser(result.data[0].user || "");
          setso_note(result.data[0].so_note || "");
          settax(result.data[0].tax || "0");
          setshipment(result.data[0].shipment || "0");
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  }, [so_id, userID, userToken]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header title="VIEW ESTIMATION" />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <Row
            xs={1}
            sm={1}
            className="justify-content-center"
            style={{
              padding: "0",
            }}
          >
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Customer: </label>
                  <input
                    required
                    type="text"
                    name="customer"
                    value={customer}
                    placeholder="Customer"
                    className="input"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-lg-12 mt-2">
                <div className="form-group">
                  <label className="label">Contact:</label>
                  <input
                    type="text"
                    name="contact"
                    value={project_name}
                    placeholder="Contact"
                    className="input"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-lg-12 mt-2">
                <div className="form-group">
                  <label className="label">Shipment: </label>
                  <input
                    placeholder="Shipment"
                    value={shipment}
                    className="input"
                    readOnly
                  />
                </div>
              </div>
            </Col>

            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Order Status: </label>
                  <input
                    type="text"
                    placeholder="Order Status"
                    value={status}
                    className="input"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-lg-12 mt-2">
                <div className="form-group">
                  <label className="label">User: </label>
                  <input
                    placeholder="User"
                    value={user}
                    className="input"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-lg-12 mt-2">
                <div className="form-group">
                  <label className="label">Tax: </label>
                  <input
                    placeholder="Tax"
                    value={tax}
                    className="input"
                    readOnly
                  />
                </div>
              </div>
            </Col>

            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Total Price:</label>
                  <input
                    type="text"
                    name="state"
                    value={total_price}
                    placeholder="Total"
                    className="input"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-lg-12 mt-2">
                <div className="form-group">
                  <label className="label">Estimate DateTime:</label>
                  <input
                    placeholder="Sale DateTime"
                    value={sale_date}
                    className="input"
                    readOnly
                  />
                </div>
              </div>
              <br />
            </Col>

            <Col md={12} className="container-col">
              <div className="col-lg-12 mt-2">
                <div className="form-group">
                  <label className="label">Note:</label>
                  <textarea
                    placeholder="Note"
                    value={so_note}
                    id="noteTextarea"
                    //   value={street_address}
                    //   onChange={handleChangeAddress}
                    rows="2"
                    className="textarea"
                    readOnly
                    style={{ height: "40px", width: "95%" }}
                  />
                </div>
              </div>
              <br />
            </Col>
          </Row>

          <GridComponent
            dataSource={AllProducts}
            allowPaging={true}
            pageSettings={{
              pageSize: 10,
              pageSizes: [10, 16, 48, 100, "All"],
            }}
            height="calc(48vh - 60px)"
            allowSorting
            //toolbar={["Search"]}
            allowResizing
            className="custom-grid"
            rowHeight={36}
          >
            <ColumnsDirective>
              {customersGrid.map((item, index) => (
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject services={[Page, Toolbar, Selection, Edit, Sort, Filter]} />
          </GridComponent>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Back"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewEstimation;
